import { render, staticRenderFns } from "./VoiceActing.vue?vue&type=template&id=2602109a&lang=pug&"
import script from "./VoiceActing.vue?vue&type=script&lang=js&"
export * from "./VoiceActing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports